import { Container, Spinner } from "react-bootstrap";
import {DriverTimeSheet, EventResourceUse, ParentContainerStyle, TimeSheet, UserRoles, WorkEvent} from "../../types";
import React, {useEffect, useState} from "react";
import {Navigate, useParams} from "react-router-dom";
import {getDriverTimesheets, getEvents, getResourceUses, getTimesheets} from "../../api/dataService";
import {useSelector} from "react-redux";
import {RootState} from "../../redux/reduxTypes";
import StackedContentContainer from "../ContentContainer";
import ViewEvent from "../ViewEvent";
import {checkIsAllowed} from "../../util/Helpers";



const ViewEventPage = () => {
    const {id} = useParams<{ id: string }>();
    const user = useSelector((state: RootState) => state.user)
    const [currentEvent, setCurrentEvent] = useState<WorkEvent>()
    const [resourcesOnEvent, setResourcesOnEvent] = useState<EventResourceUse[]>([])
    const [timesheetsOnEvent, setTimesheetsOnEvent] = useState<(TimeSheet | DriverTimeSheet)[]>([])
    useEffect(() => {
        let timesheet_filters = checkIsAllowed(user.groups, ['Ownership_Group','Office_Admin','Dispatch']) ? 
            `?event=${id}` : `?employee=${user.userid}&event=${id}`

        // Check if user is a Labourer
        const isLabourer = checkIsAllowed(user.groups, [UserRoles.labourer]);

        Promise.all([
            getEvents(id),
            getTimesheets(undefined, timesheet_filters),
            getDriverTimesheets(undefined, timesheet_filters),
            getResourceUses(undefined, `?event=${id}`)
        ])
            .then(([eventResponse, timesheetResponse, driverTimesheetResponse, resourceResponse]) => {
                if('redirectTo' in eventResponse) {return (<Navigate to={eventResponse.redirectTo}/>)}
                if('redirectTo' in timesheetResponse) {return (<Navigate to={timesheetResponse.redirectTo}/>)}
                if('redirectTo' in driverTimesheetResponse) {return (<Navigate to={driverTimesheetResponse.redirectTo}/>)}
                if('redirectTo' in resourceResponse) {return (<Navigate to={resourceResponse.redirectTo}/>)}

                if (eventResponse && !Array.isArray(eventResponse)){
                    setCurrentEvent(eventResponse)
                }

                // Combine regular and driver timesheets
                let allTimesheets: (TimeSheet | DriverTimeSheet)[] = [];

                if(timesheetResponse && Array.isArray(timesheetResponse)){
                    allTimesheets = [...allTimesheets, ...timesheetResponse];
                }

                if(driverTimesheetResponse && Array.isArray(driverTimesheetResponse)){
                    // If user is a General Labourer, don't include driver timesheets
                    if (!isLabourer) {
                        allTimesheets = [...allTimesheets, ...driverTimesheetResponse];
                    }
                }

                // Filter out deleted timesheets
                const filteredTimesheets = allTimesheets.filter(entry => entry.status !== 'deleted');
                setTimesheetsOnEvent(filteredTimesheets);

                if(resourceResponse && Array.isArray(resourceResponse)){
                    setResourcesOnEvent(resourceResponse)
                }

            })
    }, [id, user]);


    return (

        <Container style={ParentContainerStyle}>
            {currentEvent ?
                (<ViewEvent eventToView={currentEvent} resourcesOnEvent={resourcesOnEvent}  timeEntries={timesheetsOnEvent}/>)
                :
                (
                    <StackedContentContainer>
                        <Spinner animation="border" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </Spinner>
                    </StackedContentContainer>
                )}
        </Container>
    )
}


export default ViewEventPage;
